export default __webpack_public_path__ + "static/media/american-flag.cb5875e9.png";